import { render, staticRenderFns } from "./SideDrawerDetails.vue?vue&type=template&id=ea781372&"
import script from "./SideDrawerDetails.vue?vue&type=script&lang=js&"
export * from "./SideDrawerDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports